import * as Sentry from "@sentry/browser";
import { BrowserTracing } from "@sentry/tracing";

export const initSentry = () => {
  const dsn = window.global_values['SETTINGS__SENTRY__DSN']

  // https://docs.sentry.io/clients/javascript/tips/
  // Errors to ignore on Sentry, likely caused by browsers/extensions/webviews
  const ignoreErrors = [
    // Random plugins/extensions
    'top.GLOBALS',
    // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
    'originalCreateNotification',
    'canvas.contentDocument',
    'MyApp_RemoveAllHighlights',
    'http://tt.epicplay.com',
    'Can\'t find variable: ZiteReader',
    'http://loading.retry.widdit.com/',
    'atomicFindClose',
    // Facebook borked
    'fb_xd_fragment',
    // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
    // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
    'bmi_SafeAddOnload',
    'EBCallBackMessageReceived',
    // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
    'conduitPage',
    // Generic error code from errors outside the security sandbox
    // You can delete this if using raven.js > 1.0, which ignores these automatically.
    'Script error.',
    // Avast extension error
    "_avast_submit",
    // === 2025-12 新增：過濾第三方服務造成的網路錯誤雜訊 ===
    // 廣告攔截器和防火牆造成的 XMLHttpRequest 錯誤
    "Failed to execute 'send' on 'XMLHttpRequest'",
    // 通用網路錯誤（通常來自廣告或追蹤腳本）
    "A network error occurred.",
    // Klaviyo 或其他第三方服務動態載入失敗
    /Loading chunk .* failed/,
    // 非法調用錯誤（通常來自廣告腳本）
    "TypeError: Illegal invocation",
    // === Mobile 錯誤過濾 ===
    /window\.webkit\.messageHandlers/,        // iOS WebView 通訊錯誤
    /Unreachable hosts.*algolia/i,            // Algolia 網路錯誤
    /Load failed.*\.(jpg|jpeg|png|gif|webp|svg)/i,  // 圖片載入失敗（CDN/網路問題）
    "Unexpected token 'else'"                  // Android WebView 語法錯誤
  ]

  const denyUrls = [
    // Google Adsense
    /pagead\/js/i,
    // Facebook flakiness
    /graph\.facebook\.com/i,
    // Facebook blocked
    /connect\.facebook\.net\/en_US\/all\.js/i,
    // Woopra flakiness
    /eatdifferent\.com\.woopra-ns\.com/i,
    /static\.woopra\.com\/js\/woopra\.js/i,
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/\//i,
    /^chrome-extension:\/\//i,  // Chrome 擴充功能
    // Other plugins
    /127\.0\.0\.1:4001\/isrunning/i,  // Cacaoweb
    /webappstoolbarba\.texthelp\.com\//i,
    /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
    //第三方服務來源的錯誤
    /adsrvr\.org/i,              // 廣告追蹤服務
    /api\.ipify\.org/i,          // IP 查詢服務
    /static\.klaviyo\.com/i,     // Klaviyo 行銷服務
    /googletagmanager\.com/i,    // Google Tag Manager
    /gtm\.js/i,                  // Google Tag Manager
    /analytics\.google\.com/i,   // Google Analytics
    /pagead2\.googlesyndication\.com/i  // Google Ads
  ]

  if(dsn) {
    Sentry.init({
      dsn,
      integrations: [new BrowserTracing()],
      ignoreErrors,
      denyUrls,
      // 過濾爬蟲和機器人產生的錯誤
      beforeSend(event) {
        const userAgent = event.request?.headers?.['User-Agent'] ||
                         event.contexts?.browser?.name || '';
        const botPatterns = [
          /bot/i,
          /spider/i,
          /crawler/i,
          /baiduspider/i,
          /googlebot/i,
          /bingbot/i,
          /yandex/i,
          /slurp/i,
          /duckduckbot/i,
          /facebookexternalhit/i,
          /linkedinbot/i,
          /twitterbot/i,
          /whatsapp/i,
          /telegrambot/i
        ];
        if (botPatterns.some(pattern => pattern.test(userAgent))) {
          return null;
        }
        return event;
      }
    })
  } else {
    console.log('sentry init failed')
  }
}
